import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { TimeSeriesCard } from "./card";
import { TimeSeriesNew } from "./new";
import { setDocumentTitle } from "@/lib/documentTitle";

import { TimeSeriesTable } from "./table";

export default function TimeSeries() {
  useEffect(() => {
    // Set the tab title in French
    setDocumentTitle("Quantilia | Séries temporelles");
  }, []);

  return (
    <Routes>
      <Route index element={<TimeSeriesTable />} />
      <Route path="/new" element={<TimeSeriesNew />} />
      <Route path=":id" element={<TimeSeriesCard />} />
    </Routes>
  );
}
